import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface PageStatusState {
  pageNotFound: boolean;
  isSiteUnavailable: boolean;
  isProjectResourceUnavailable: boolean;
}

const initialState: PageStatusState = {
  pageNotFound: false,
  isSiteUnavailable: false,
  isProjectResourceUnavailable: false,
};

const pageStatusSlice = createSlice({
  name: 'pageStatus',
  initialState,
  reducers: {
    setPageNotFound: (state, pageNotFound: PayloadAction<boolean>) => {
      state.pageNotFound = pageNotFound.payload;
    },
    setIsSiteUnavailable: (
      state,
      isSiteUnavailable: PayloadAction<boolean>,
    ) => {
      state.isSiteUnavailable = isSiteUnavailable.payload;
    },
    setIsProjectResourceUnavailable: (
      state,
      isProjectResourceUnavailable: PayloadAction<boolean>,
    ) => {
      state.isProjectResourceUnavailable = isProjectResourceUnavailable.payload;
    },
  },
});

export const {
  setPageNotFound,
  setIsSiteUnavailable,
  setIsProjectResourceUnavailable,
} = pageStatusSlice.actions;

export default pageStatusSlice.reducer;
